export const GET_STATES_REQ = "GET_STATES_REQ"
export const GET_STATES_REQ_FAIL = "GET_STATES_REQ_FAIL"
